<script setup lang="ts">
import { SolCheckbox } from '@solfacil/girassol'

defineProps<{
  id: string
  name: string
  value: string
  checked: boolean
}>()

const emit = defineEmits<{
  change: []
}>()
</script>

<template>
  <div class="revalidation-auth-box">
    <SolCheckbox
      :id="id"
      :name="name"
      :value="value"
      :checked="checked"
      class="revalidation-auth-box-checkbox"
      @change="emit('change')"
    >
      <span class="revalidation-auth-box-text">
        <slot />
      </span>
    </SolCheckbox>
  </div>
</template>

<style scoped lang="scss">
.revalidation-auth-box {
  --revalidation-modal-content-pad: 1.5rem;

  box-sizing: border-box;
  width: calc(100% + 2 * var(--revalidation-modal-content-pad));
  max-width: none;
  margin-left: calc(-1 * var(--revalidation-modal-content-pad));
  margin-right: calc(-1 * var(--revalidation-modal-content-pad));
  min-width: 0;
  @apply rounded-none border-l-0 border-r-0 border-t border-b border-solid border-neutral-high-light bg-feedback-positive-light;
  @apply py-4;
  padding-left: var(--revalidation-modal-content-pad);
  padding-right: var(--revalidation-modal-content-pad);

  .revalidation-auth-box-checkbox {
    @apply w-full min-w-0 max-w-full;

    :deep(label) {
      @apply flex w-full min-w-0 flex-row items-start gap-3;
      margin: 0;
      cursor: pointer;
    }

    :deep(input[type='checkbox']) {
      flex-shrink: 0;
      margin-top: 0.125rem;
    }
  }

  .revalidation-auth-box-text {
    flex: 1 1 0%;
    min-width: 0;
    @apply fonts-body-medium-regular text-neutral-low-dark leading-[1.625];

    :deep(.revalidation-submit-modal-inline-link) {
      @apply fonts-body-medium-regular text-brand-primary-medium underline;
      text-underline-offset: 2px;
    }
  }
}
</style>
